<template>
  <div class="service-float">
    <div class="service-item" @mouseenter="showQR = true" @mouseleave="showQR = false">
      <div class="service-icon flex-center">
        <i class="el-icon-headset"></i>
      </div>
      <div class="service-label">在线客服</div>
      
      <!-- 二维码弹出层 -->
      <transition name="fade-slide">
        <div v-if="showQR && imgList.length" class="qr-modal card-modern">
          <div class="qr-content">
            <img :src="imgList[0].picLoad" alt="客服二维码" />
            <p>扫码咨询客服</p>
          </div>
          <div class="arrow"></div>
        </div>
      </transition>
    </div>

    <!-- 回到顶部按钮 (可选，如果页面长的话建议加上) -->
    <div class="service-item back-top" v-show="showBackTop" @click="scrollToTop">
      <div class="service-icon flex-center">
        <i class="el-icon-caret-top"></i>
      </div>
    </div>
  </div>
</template>

<script>
import article from "@/api/article";
export default {
  name: "Service",
  data() {
    return {
      showQR: false,
      showBackTop: false,
      imgList: [],
    };
  },
  mounted() {
    this.getBannerList();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getBannerList() {
      article.bannerList({ belongPage: "foot" }).then((res) => {
        this.imgList = res.data.data.records;
      });
    },
    handleScroll() {
      this.showBackTop = window.scrollY > 400;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
};
</script>

<style scoped lang="less">
@import "../assets/styles/variables.less";

.service-float {
  position: fixed;
  right: 30px;
  bottom: 15%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.service-item {
  width: 60px;
  height: 60px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: @shadow-md;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  border: 1px solid @border-color;

  &:hover {
    background-color: @primary-color;
    color: #ffffff;
    transform: translateX(-4px);
    
    .service-icon i { color: #ffffff; }
    .service-label { color: #ffffff; }
  }

  .service-icon {
    font-size: 24px;
    i { color: @primary-color; transition: color 0.3s; }
  }

  .service-label {
    font-size: 10px;
    margin-top: 4px;
    color: @text-secondary;
    transition: color 0.3s;
  }
}

.qr-modal {
  position: absolute;
  right: 75px;
  top: 50%;
  transform: translateY(-50%);
  background: #ffffff;
  padding: 16px;
  width: 140px;
  text-align: center;
  pointer-events: none;

  img {
    width: 100%;
    height: auto;
    margin-bottom: 8px;
  }

  p {
    font-size: 12px;
    color: @text-main;
    font-weight: 500;
  }

  .arrow {
    position: absolute;
    right: -8px;
    top: 50%;
    margin-top: -8px;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid #ffffff;
  }
}

/* 动画 */
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-slide-enter {
  opacity: 0;
  transform: translate(10px, -50%);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translate(10px, -50%);
}
</style>
